// extracted by mini-css-extract-plugin
export default {"loaderContainer":"MultifactorAuthManagement_loaderContainer__0+Dv1","container":"MultifactorAuthManagement_container__MoLoQ","info":"MultifactorAuthManagement_info__72sya"};